import type { LinkedAlert, AlertId } from '../../common/types';

export const getSelectableAlertIds = (alerts: LinkedAlert[]): AlertId[] =>
	alerts.filter((alert) => !alert.isLinked).map((alert) => alert.id);
